import jwtDecode, { JwtPayload } from 'jwt-decode';
import { DevsiteCookies, DevsiteOrgCookies } from 'shared/models/cookies';
import { FEDERAL_MODE } from 'config/toggles';
import { getTokenExpiration } from 'modules/core/auth/token';
import { getCookie, getOrgCookie, removeOrgCookie, setOrgCookie } from '../DevsiteCookies';

let fedToken: string | undefined;
// appPreviewFedTokens and deployFedTokens are objects with orgUUids as keys
const appPreviewFedTokens: Record<string, string> = {};
const deployFedTokens: Record<string, string> = {};

export const getOrgTenantAuthExpiresAt = (orgUuid: string, tokenKey: DevsiteOrgCookies): number => {
  const token = getOrgTenantAuthToken(orgUuid, tokenKey);
  // @ts-expect-error DEVEXTOOLS-1514: fix strictNullChecks rule violation
  return token ? getTokenExpiration(token) : null;
};

const getAuthorizedOrgTenantAlias = (orgUuid: string, tokenKey: DevsiteOrgCookies): string => {
  const token = getOrgTenantAuthToken(orgUuid, tokenKey);
  // @ts-expect-error DEVEXTOOLS-1514: fix strictNullChecks rule violation
  return token ? jwtDecode<JwtPayload & { tenant?: string }>(token).tenant : null;
};
export const getAppPreviewAuthorizedTenantAlias = (orgUuid: string) =>
  getAuthorizedOrgTenantAlias(orgUuid, DevsiteOrgCookies.QUICK_VIEW_TENANT_AUTH_TOKEN);
export const getDeployAuthorizedTenantAlias = (orgUuid: string) =>
  getAuthorizedOrgTenantAlias(orgUuid, DevsiteOrgCookies.DEPLOY_TENANT_AUTH_TOKEN);

// TODO: WCPX-8189 eventually update to use server API to be more secure and fedramp compliant
export const getTenantAuthToken = () => {
  let token;
  if (FEDERAL_MODE) {
    token = fedToken;
  } else {
    token = getCookie(DevsiteCookies.TENANT_AUTH_TOKEN);
  }
  if (token) {
    const expiresAt = getTokenExpiration(token);
    if (expiresAt && expiresAt > Date.now()) return token;
  }
  return null;
};
/**
 * @description gets the tenant id by searching for 'tenant-access-token-{orgUUID}` in cookies.
 * @returns the active tenant cookie
 */
export const getTenantAuthTokenWithOrgId = () => {
  const orgId = getCookie(DevsiteCookies.WCP_ORG_UUID);
  // @ts-expect-error DEVEXTOOLS-1514: fix strictNullChecks rule violation
  const tenantCookie: string = getOrgCookie(DevsiteOrgCookies.TENANT_AUTH_TOKEN, orgId);
  return tenantCookie;
};

const getOrgTenantAuthToken = (orgUuid: string, tokenKey: DevsiteOrgCookies) => {
  let token;

  if (FEDERAL_MODE) {
    if (tokenKey === DevsiteOrgCookies.DEPLOY_TENANT_AUTH_TOKEN) {
      token = deployFedTokens[orgUuid];
    }
  } else {
    token = getOrgCookie(tokenKey, orgUuid);
  }

  if (token) {
    try {
      const expiresAt = getTokenExpiration(token);
      if (expiresAt && expiresAt > Date.now()) return token;
    } catch (error) {
      // invalid token
      return null;
    }
  }
  return null;
};

// This is used for non-Fed flow
export const setOrgTenantAuthToken = (token: string, orgUuid: string, tokenKey: DevsiteOrgCookies) => {
  if (FEDERAL_MODE) {
    if (tokenKey === DevsiteOrgCookies.DEPLOY_TENANT_AUTH_TOKEN) {
      deployFedTokens[orgUuid] = token;
    }
  } else {
    const expiration = getTokenExpiration(token);
    const expirationDate = expiration ? new Date(expiration) : null;
    // @ts-expect-error DEVEXTOOLS-1514: fix strictNullChecks rule violation
    setOrgCookie(tokenKey, token, orgUuid, expirationDate);
  }
};

export const setDeployTenantAuthToken = (token: string, orgUuid: string) =>
  setOrgTenantAuthToken(token, orgUuid, DevsiteOrgCookies.DEPLOY_TENANT_AUTH_TOKEN);

export const removeOrgTenantAuthToken = (orgUuid: string, tokenKey: DevsiteOrgCookies) => {
  if (FEDERAL_MODE) {
    if (tokenKey === DevsiteOrgCookies.QUICK_VIEW_TENANT_AUTH_TOKEN) {
      appPreviewFedTokens[orgUuid] = '';
    } else if (tokenKey === DevsiteOrgCookies.DEPLOY_TENANT_AUTH_TOKEN) {
      deployFedTokens[orgUuid] = '';
    }
  } else {
    removeOrgCookie(tokenKey, orgUuid);
  }
};
